import { render, staticRenderFns } from "./CompanyPersonsPost.vue?vue&type=template&id=2825cf98&scoped=true&"
import script from "./CompanyPersonsPost.vue?vue&type=script&lang=js&"
export * from "./CompanyPersonsPost.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPersonsPost.vue?vue&type=style&index=0&id=2825cf98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825cf98",
  null
  
)

export default component.exports